import { render, staticRenderFns } from "./MultipleChoiceExercises.vue?vue&type=template&id=0a6d1e30"
import script from "./MultipleChoiceExercises.vue?vue&type=script&lang=js"
export * from "./MultipleChoiceExercises.vue?vue&type=script&lang=js"
import style0 from "./MultipleChoiceExercises.vue?vue&type=style&index=0&id=0a6d1e30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports